/**
 * @module ui/templates/onboarding-message
 */
import tgamConfig from "config/tgam";

/**
 * Returns markup for Onboarding Message's button.
 * @param {String} [theme=""] - theme to use
 * @returns {String} HTML for Onboarding Mesage's button
 */
function dismissButtonMarkup(theme="") {
  return `
    <button class="c-button c-button--icon-only c-button--small c-button--no-border${theme ? " c-button--" + theme : ""}" type="button" aria-label="Close message">
      <svg class="c-button__icon" role="img" pointer-events="none" focusable="false" aria-hidden="true">
        <use xlink:href="${tgamConfig.env.svgSpritePath}#close-x"></use>
      </svg>
    </button>
  `;
}

/**
 * Returns markup for Onboarding Message.
 * @param {String} id - a unique ID
 * @param {String} messageText - message text
 * @param {String} [theme=""] - theme to use (Possible values: "" for default, "white", "dark" or "blue-primary")
 * @param {String} [messagePosition="top"] - position of Onboarding Mesage itself (possible values: "top", "middle" or "bottom")
 * @param {String} [arrowPosition="left"] - position of Onboarding Mesage arrow (possible values: "left", "center" or "right")
 * @param {Boolean} [staticPos=true] - whether the Onboarding Mesage is statically-positioned as opposed to absolutely-positioned
 * @param {Boolean} [dismissable=true] - whether the Onboarding Mesage will contain a dismiss button
 * @returns {String} HTML for Onboarding Mesage
 */
export function onboardingMessageMarkup(id, messageText, theme="", messagePosition = "top", arrowPosition = "left", staticPos = true, dismissable = true) {
  return `
    <div class="c-onboarding-message ${staticPos ? "c-onboarding-message--static" : ""}${theme ? " c-onboarding-message--" + theme : ""}${dismissable ? " c-onboarding-message--dismissable" : ""} c-onboarding-message--pos-${messagePosition} c-onboarding-message--pos-${arrowPosition}" id="${id}" ${staticPos ? "" : "hidden role='status'"}>
      <div class="c-onboarding-message__inner">
        ${messageText} ${dismissable ? dismissButtonMarkup(theme) : ""}
      </div>
    </div>
  `;
}
